import { createContext, type ReactNode, useContext } from 'react';

import type { UseDateRangePickerResult } from '@/hooks/useDateRangePicker';

const HealthOverviewDateRangeContext = createContext<UseDateRangePickerResult | null>(null);

export function HealthOverviewDateRangeProvider(props: {
    value: UseDateRangePickerResult;
    children: ReactNode;
}): React.ReactElement {
    return (
        <HealthOverviewDateRangeContext value={props.value}>
            {props.children}
        </HealthOverviewDateRangeContext>
    );
}

export function useHealthOverviewDateRange(): UseDateRangePickerResult | null {
    return useContext(HealthOverviewDateRangeContext);
}
